import React, { useCallback, useRef } from 'react';
import { TargetApplicantProps } from './target-applicant.component';
import { JsonObject } from 'src/app/common/components/data-uploader/data-uploader.component';
import { EnrolmentType, WalletAwardFormMode } from 'src/app/modules/pruwallet/types/award-type';

export const useTargetApplicant = (props: TargetApplicantProps) => {
  const refInitEnrolmentType = useRef(props?.formState?.enrolmentType);

  const isShowAgentDownload =
    refInitEnrolmentType.current === EnrolmentType.SPECIFIC &&
    props?.formState?.agentListUploaded &&
    props?.formState?.agentListUploaded?.length;

  const handlePress = useCallback(() => {}, []);
  const validateUploadedData = useCallback((data: JsonObject[]) => {
    const arr = dataConvert(data);
    if (arr && arr.length) {
      return true;
    }
    return false;
  }, []);

  /**
   * get & convert Uploaded agent list to download format
   * data sample: ["00010001","00010007"]
   * @returns sample: [{agentCode: "00010001", agentCode: "00010007"}]
   */
  const getUploadedAgents = () => {
    const arr = props?.formState?.agentListUploaded || [];
    return arr.map((agentCode) => {
      return { agentCode: agentCode };
    });
  };

  return {
    isShowAgentDownload,
    handlePress,
    getUploadedAgents,
    validateUploadedData,
  };
};
/**
 * uploaded JsonObject array convert to string array
 * sample: [{agentCode: "00010001", agentCode: "00010007"}] => ["00010001",00010007]
 * @param arr
 */
export function dataConvert(agents: JsonObject[]) {
  const agentCodes = agents
    ? agents
        ?.map((agent) => agent.agentCode) // Extract agent codes
        .filter((code) => code !== undefined && code !== '') // Filter out undefined and empty string values
        .map((code) => String(code)) // to string
    : []; // Return an empty array

  return agentCodes;
}
